import { Component, OnInit, OnDestroy } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { TrustDataService } from '../../services/trust-data-service/trust-data.service';
import { ReportConfiguration } from '../../models/report-configuration';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggingService } from '../../services/logging-service/logging.service';
import { UserSessionService } from '../../services/user-session-service/user-session.service';

@Component({
  selector: 'app-portal-admin-report-config',
  templateUrl: './portal-admin-report-config.component.html',
  styleUrls: ['./portal-admin-report-config.component.css']
})
export class PortalAdminReportConfigComponent implements OnInit, OnDestroy {

  loaded = false;
  error = false;

  reportConfigurationList: ReportConfiguration[];
  reportConfiguration: Subscription;
  updateConfiguration: Subscription;

  constructor(private shellUpdateService: ShellUpdateService, private appConfigService: AppConfigService,
    private trustDataService: TrustDataService, private snackBar: MatSnackBar, private loggingService: LoggingService,
    private userSessionService: UserSessionService) { }

  ngOnInit() {

    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, 'Report Configuration', null, null));
    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, false, true));

    // Get all of the available reports
    this.reportConfiguration = this.trustDataService.getTrustReportConfiguration()
      .pipe(map(response => response.json()))
      .subscribe(response => {
        this.reportConfigurationList = response;
        this.loaded = true;
        this.loggingService.log('Loaded trust report configuration', this.appConfigService.LogToConsole);
      }, (error => {
        this.handleError(error);
        this.loggingService.log('Error loading trust configuration', this.appConfigService.LogToConsole);
        this.loaded = true;
      }));
  }

  // Unsubscribe so we don't get memory leaks
  ngOnDestroy() {
    if (this.reportConfiguration) {
      this.reportConfiguration.unsubscribe();
      this.loggingService.log('Cleaned subscription', this.appConfigService.LogToConsole);

    }

    if (this.updateConfiguration) {
      this.updateConfiguration.unsubscribe();
      this.loggingService.log('Cleaned subscription', this.appConfigService.LogToConsole);
    }
  }

  // Send the configuration updates to the server
  updateConfig(config: any) {
    this.loggingService.log('Updated configuration.', this.appConfigService.LogToConsole);
    let updateText = null;

    if (config.Show) {
      updateText = 'shown';
    } else {
      updateText = 'hidden';
    }

    this.updateConfiguration = this.trustDataService.updateReportConfiguration(config).subscribe(response => {
      this.snackBar.open(`${config.FriendlyName} - ${updateText}`, null, { duration: 5000 });
    }, (error => {
      this.handleError(error);
    }));
  }

  // Handles any potential http errors
  handleError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. You appear to be offline.', '', { duration: 5000 });
        this.loggingService.log('Error - offline', this.appConfigService.LogToConsole);
        break;
      case 401:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. Your login has expired.', '', { duration: 5000 });
        this.loggingService.log('Error - login expired', this.appConfigService.LogToConsole);
        this.userSessionService.logout();
        break;
      case 500:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. Server error.', '', { duration: 5000 });
        this.loggingService.log('Error - Server error', this.appConfigService.LogToConsole);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/portal-admin-report-config/portal-admin-report-config.component.ts